module.exports = __webpack_public_path__ + "img/ResidentOffice2.33f44b11.png";